export default {
      id: "rx-usage",
      viewBox: "0 0 389.000000 215.000000",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#rx",
      toString: function () {
        return this.url;
      }
    }